import { render } from "./DuplicateModal.vue?vue&type=template&id=7a21c272&scoped=true"
import script from "./DuplicateModal.vue?vue&type=script&lang=js"
export * from "./DuplicateModal.vue?vue&type=script&lang=js"

import "./DuplicateModal.vue?vue&type=style&index=0&id=7a21c272&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a21c272"]])

export default __exports__